import type { PositionedItem } from '../../PageConfigProvider/types/item';

export const isSingleEntityChart = (item: PositionedItem) => {
  const { plot } = item;
  const { chartType, secondaryDimension } = plot || {};
  const metric = plot?.defaultMetricOptions?.[0];
  const dimensionSource = plot?.dimensionSource;

  const isTopN = !!dimensionSource && dimensionSource !== 'primary';

  const isTotalSpendBreakdown =
    (metric === 'total_spend_salary' ||
      metric === 'total_spend_compensation') &&
    !!secondaryDimension;

  const isTreemapBreakdown = chartType === 'treemap' && !!secondaryDimension;

  return (
    chartType === 'sankey' ||
    chartType === 'volume' ||
    chartType === 'sentiment_review' ||
    metric === 'sentiment_top_bottom' ||
    isTopN ||
    isTotalSpendBreakdown ||
    isTreemapBreakdown
  );
};
